<template>
  <form novalidate class="md-layout-item md-size-100 md-small-size-100" @submit.prevent="validateContractSignGroup()">
        <md-content class="md-layout-item md-pd-16 md-size-100 md-small-size-100">
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                    <md-field :class="getContractSignGroupValidationClass('name')">
                        <label for="contractSignGroup-name">Nazwa</label>
                        <md-input name="contractSignGroup-name" id="contractSignGroup-name" v-model="contractSignGroup.name" />
                        <span class="md-error" v-if="!$v.contractSignGroup.name.required">{{ $t('views.admin.configurations.contractSign.groupTable.name') }}</span>
                    </md-field>
                </div>
</div>
          <md-field :class="getContractSignGroupValidationClass('requiredSignatures')">
            <label for="contractSignGroup-requiredSignatures">Wymagana liczba podpisów pod kontraktem</label>
            <md-select @change="showGroups()" v-model="contractSignGroup.requiredSignatures" name="contractSignGroup-requiredSignatures" id="contractSignGroup-requiredSignatures">
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
            </md-select>
            <span class="md-error" v-if="!$v.contractSignGroup.requiredSignatures">{{ $t('views.admin.configurations.contractSign.groupTable.requiredSignatures') }}</span>
          </md-field>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getContractSignGroupValidationClass('limit')">
                <label for="contractSignGroup-limit">Limit</label>
                <md-input name="contractSignGroup-limit" id="contractSignGroup-limit"
                          :value="formatLocaleNumber(contractSignGroup.limit)"
                          @input="setValue(getParsedLocaleNumberOrInputString($event), 'contractSignGroup.limit')"
                          autocomplete="off" />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getContractSignGroupValidationClass('monthlyLimit')">
                <label for="contractSignGroup-monthlyLimit">Limit miesięczny</label>
                <md-input name="contractSignGroup-monthlyLimit" id="contractSignGroup-monthlyLimit"
                          :value="formatLocaleNumber(contractSignGroup.monthlyLimit)"
                          @input="setValue(getParsedLocaleNumberOrInputString($event), 'contractSignGroup.monthlyLimit')"
                          autocomplete="off" />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter" v-if="showGroups()">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getContractSignGroupValidationClass('contractSignGroups')" style="flex-wrap: wrap;">
            <label class="md-layout-item md-caption">Drugi podpis może złożyć</label>
                <div v-for="(item, index) in contractSignGroup.contractSignGroups" :key="item.valueId">
                  <md-checkbox v-model="contractSignGroup.contractSignGroups[index].checked" class="md-warn">{{ item.name ? item.name:contractSignGroup.contractSignGroups[index].name }}</md-checkbox>
                </div>
                <md-checkbox v-if="!edit" v-model="contractSignGroup.signWithTheSameGroup">Z samą sobą</md-checkbox>
              </md-field>
            </div>
          </div>
          <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30" style="min-height: 50px">
            <div class="button-actions">
              <md-button class="md-form-btn-cancel md-mr-30" @click="cancel">
                {{ $t('cancel') }}
              </md-button>
              <md-button class="md-form-btn-white" @click="onContractSignGroupSaved()">{{ $t('save') }}</md-button>
            </div>
          </div>
        </md-content>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {configurationsEndpoint} from '@/services/adsign-backend/endpoints';
  import orderCommons from '@/mixins/orderCommons';

  export default {
    name: 'ContractSignGroupForm',
    mixins: [validationMixin,orderCommons],
    props: {
      id: {
        type: Number,
        default: undefined
      },
      groups:{
        type:Array,
        default:undefined
      },
      item: {
        type: Object,
        default: undefined
      },
      agency:{
        type:Number,
        default:undefined
      },
      index: {
        type: Number,
        default: undefined
      },
      contractGroups: {
        type:Array,
        default:undefined
      }
    },
    computed: {
      edit: {
        get() {
          return this.id !== undefined;
        }
      }
    },
    data: () => ({
      values: [],
      contractSignGroup: {
        id: null,
        name: null,
        requiredSignatures:null,
        agency:null,
        limit:null,
        monthlyLimit:null,
        index: null,
        contractSignGroups:[],
        signWithTheSameGroup:null
      }
    }),

    validations: {
      contractSignGroup: {
        id: {
          required,
        },
        name: {
          required,
        },
        requiredSignatures: {
          required
        }
    }},
    mounted() {

        if(this.item === undefined){
          this.contractSignGroup.contractSignGroups = this.groups;
          this.contractSignGroup.agency = { id : this.agency };
        }else {
          this.contractSignGroup = this.item;
        }
    },
    methods: {
      getContractSignGroupValidationClass(fieldName){
        const field = this.$v.contractSignGroup[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      changeValue(){
        if(this.contractSignGroup?.signWithTheSameGroup == true){
          this.contractSignGroup.signWithTheSameGroup = false;
        }else{
          this.contractSignGroup.signWithTheSameGroup = true;
        }
      },
      validateContractSignGroup() {
        this.$v.contractSignGroup.$touch();

        if (!this.$v.contractSignGroup.$invalid) {
          this.onContractSignGroupSaved()
        }
      },
      onContractSignGroupSaved() {
        if (this.contractSignGroup.id) {
          this.updateContractSignGroup();
        } else {
            this.addContractSignGroup();
          }
        },
      updateContractSignGroup(){
        this.contractSignGroup.limit = this.removeThousandSeparator(this.contractSignGroup.limit)
        this.contractSignGroup.monthlyLimit = this.removeThousandSeparator(this.contractSignGroup.monthlyLimit)
        configurationsEndpoint.updateContractSignGroup(this.contractSignGroup)
        .then((response) => {
          this.cancel();
        })
        .catch(this.handleServerValidationError)
        .finally(() => {
              this.sending = false;
            }
        );
      },
      addContractSignGroup(){

        if(this.contractSignGroup.limit != null) {
          this.contractSignGroup.limit = this.removeThousandSeparator(this.contractSignGroup.limit)
        }
        if(this.contractSignGroup.monthlyLimit != null) {
          this.contractSignGroup.monthlyLimit = this.removeThousandSeparator(this.contractSignGroup.monthlyLimit)
        }
        configurationsEndpoint.addContractSignGroup(this.contractSignGroup)
        .then((response) => {
          this.cancel(response.data);
        })
        .catch(this.handleServerValidationError)
        .finally(() => {
              this.sending = false;
            }
        );
      },
      cancel(itemToPass) {
        if (this.index) {
          this.$emit('edit', {index: this.index, agency:this.contractSignGroup.agency.id});
        } else if (this.edit) {
          this.$router.push('/configurations/contractSign/' + this.id);
        } else if (this.agency) {
          this.$emit('add', itemToPass);
        } else {
          this.$emit('edit', null);
        }
      },
      showGroups(){
        if(this.contractSignGroup.requiredSignatures==2){
          return true;
        }else{
          return false;
        }
      }
    }
  }
</script>
